export const DISCONTS = "/disconts";
export const DISCONTS_ACTIVE = "/disconts/active";
export const DISCONTS_FIRST = "/disconts/first";
